import { v4 as uuidv4 } from 'uuid';
import {
  APPLICATION_JSON, CLIENT_ID, INCLUDE, POST,
} from '../constants/constants';
import { getTripDetailsApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    bookingDate,
    tripId,
    bookingType,
    locale,
    correlationId,
  }, action, state) => {
    const request = {
      bookingDate,
      tripId,
      bookingType,
    };
    return {
      url: `${getTripDetailsApiUrl(state)}`,
      opts: {
        method: POST,
        timeout: 30e3,
        credentials: INCLUDE,
        headers: {
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON,
          'x-correlation-id': correlationId || uuidv4(),
          'x-client-id': CLIENT_ID,
          'x-locale': locale,
          'x-user-agent': window.navigator.userAgent,
        },
        body: JSON.stringify(request),
      },
    };
  },
};
